export async function fetchTranslations(language) {
  try {
    return (await import(`../locales/messages_${language}.json`)).default;
  } catch {
    return {};
  }
}
//# sourceMappingURL=fetchTranslations.js.map